import { gql } from '@provision/graphql-client';
import { CONVERSATION_PARTICIPANT_FIELDS } from 'src/graphql/entities/conversation-participants';

export const CONVERSATION_MESSAGE_FRAGMENT = gql`
  fragment ConversationMessageFields on ConversationMessage {
    id
    conversationMessageId
    conversationId
    body
    createdAt
    editedAt
    partnerId
    isPrivate
  }
`;

export const CONVERSATION_MESSAGE_RELATION_FRAGMENT = gql`
  fragment ConversationMessageRelations on ConversationMessage {
    id
    senderChannel {
      id
      channelType {
        id
        title
      }
      conversationParticipant {
        ...ConversationParticipantFields
      }
    }
    attachments {
      id
      conversationId
      partnerId
      fileKey
      fileName
      contentType
      size
      conversationMessageId
      callTranscription {
        id
        transcriptionId
        partnerId
        transcriptText
        createdAt
      }
    }
    incomingConversationEmail {
      id
      fileKey
    }
    messageDispatches {
      id
      conversationParticipationId

      dispatchStatus
      customAttributes
      createdAt
      updatedAt
    }
    conversationSmsRecords {
      id
      conversationSmsSessionId
      direction
      externalMessageId
    }
  }
  ${CONVERSATION_PARTICIPANT_FIELDS}
`;
